<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>
          {{$t('text.editOrder.title')}}
        </p>
      </div>
      <div class="cover">
        <div class="personal">
          <label class="uplift">{{$t('text.editOrder.orderInformation')}}</label>
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editOrder.quantity')}}
                </span>
              </label>
              <div class="input__block" ref="q_inp">
                <input
                  type="number"
                  :placeholder="$t('text.editOrder.quantity')"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                  v-model="order.quantity"
                />
              </div>
              <div ref="q_err"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editOrder.contactName')}}
                </span>
              </label>
              <div class="input__block" ref="c_inp">
                <input
                  type="text"
                  :placeholder="$t('text.editOrder.contactName')"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                  v-model="order.contactName"
                />
              </div>
              <div ref="c_err"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editOrder.status')}} 
                </span>
              </label>
              <div class="input__block" ref="lname_input">
                <select v-model="order.status">
                    <option value="" disabled selected>
                        {{$t('text.editOrder.selectAStatus')}}</option>
                    <option value="Driver Assigned">{{$t('text.editOrder.driverAssigned')}}</option>
                    <option value="Payment Pending">{{$t('text.editOrder.paymentPending')}}</option>
                    <option value="Payment Completed">{{$t('text.editOrder.paymentCompleted')}}</option>
                    <option value="Payment Confirmed">{{$t('text.editOrder.paymentConfirmed')}}</option>
                    <option value="Order Completed">{{$t('text.editOrder.orderCompleted')}}</option>
                    <option value="Order Accepted">{{$t('text.editOrder.orderAccepted')}}</option>
                    <option value="Order Rejected">{{$t('text.editOrder.orderRejected')}}</option>
                    <option value="Processing">{{$t('text.editOrder.processing')}}</option>
                    <option value="In Transit">{{$t('text.editOrder.inTransit')}}</option>
                    <option value="Arrived">{{$t('text.editOrder.arrived')}}</option>
                    <option value="Owner Accepted">{{$t('text.editOrder.ownerAccepted')}}</option>
                    <option value="Fill Started">{{$t('text.editOrder.fillStarted')}}</option>
                    <option value="Fill Ended">{{$t('text.editOrder.fillEnded')}}</option>
                </select>
              </div>
              <div ref="lname_error"></div>
            </div>
              <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editOrder.product')}}
                </span>
              </label>
              <div class="input__block" ref="lname_input">
                 <select v-model="order.product" >
                        <option value="" disabled selected>
                        {{$t('text.editOrder.selectAProduct')}}</option>
                        <option :value="prod.productId" v-for="(prod, index) in prodList"
                  :key="index">{{prod.name}}</option>
                </select>
              </div>
              <div ref="lname_error"></div>
            </div>
          </div>
        </div>
        <div class="contact">
          <label class="uplift">{{$t('text.editOrder.contactInformation')}}</label>
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editOrder.street')}}
                </span>
              </label>
              <div class="input__block" ref="street_input">
                <input
                  type="text"
                  :placeholder="$t('text.editOrder.street')"
                  v-model="order.street"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="street_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editOrder.city')}}
                </span>
              </label>
              <div class="input__block" ref="city_input">
                <input
                  type="text"
                  :placeholder="$t('text.editOrder.city')"
                  v-model="order.city"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="city_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                {{$t('text.editOrder.state')}}
              </label>
              <div class="input__block">
                <select v-model="order.state"  >
                  <option :value="st.name" v-for="(st,i) in states" :key='i'>{{st.name}}</option>
                </select>
              </div>
            </div>
              <div class="input__group__block mt-4 col-md-6" style="margin: 0;">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editOrder.contactPhone')}}
                </span>
              </label>
              <div class="input__block" ref="phone_input">
                <input
                  type="text"
                  :placeholder="$t('text.editOrder.phonePlaceholder')"
                  style="width: 100%"
                  v-model="order.contactPhone"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="phone_error"></div>
            </div>
          </div>
        </div>

        <div class="text-center mt-4 pb-4">
          <button
            class="save__btn"
            @click="updateOrder($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' }
            ]"
          >
           {{$t('text.editOrder.updateOrder')}} <span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display:none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";

import JQuery from "jquery";
let $ = JQuery;

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport
} from "@syncfusion/ej2-vue-grids";

export default {
  title: 'Edit Order :: Epump Portal',
  name: "Edit Order",
  components: {
    MasterLayout
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport]
  },
  data() {
    return {
      prodArray: [],
      prodList: [],
      quantity: null,
      order: {},
      contactName: null,
      paymentMode: "cash",
      paid: null,
      state: "Lagos",
      phone: null,
      paid: "true",
      street: "",
      city: "",
      states: [],
      branch: {},
      branchId: null,
      company: null,
      formIsValid: false,
      isButtonDisabled: false,
      date: new Date(),
      showLoader: true,
      retainerships: null,
      backgroundUrl,
      payTime: "",
      fileDisabled: true,
      pageSettings: { pageSizes: [10,20, 50, 100, 200], pageCount: 4, pageSize: 10 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getStates();
        this.getProducts();
        this.getPreviousOrderAddress();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if(this.$route.query.companyId){
      this.getStates();
      this.getProducts();
      this.getPreviousOrderAddress();
    }
    this.order = JSON.parse(localStorage.getItem("orders")).filter(
      order => order.id == this.$route.query.id
    )[0];

  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {
    
    captureFormEvents($event) {
      if ($event.target.placeholder === this.$t('text.editOrder.quantity')) {
        if ($event.target.value === "") {
          this.$refs.q_err.style.display = "block";
          // this.$refs.q_err.innerHTML = this.$t('text.editOrder.quantityMissing');
          this.$refs.q_inp.style.border = "1px solid red";
          this.$refs.q_err.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.q_err.style.display = "none";
          this.$refs.q_err.innerHTML = "";
          this.$refs.q_inp.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
       if ($event.target.placeholder === this.$t('text.editOrder.contactName')) {
        if ($event.target.value === "") {
          this.$refs.c_inp.style.display = "block";
          // this.$refs.c_err.innerHTML = this.$t('text.errors.contactNameMissing');
          this.$refs.c_inp.style.border = "1px solid red";
          this.$refs.c_err.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.c_err.style.display = "none";
          this.$refs.c_err.innerHTML = "";
          this.$refs.c_inp.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t('text.editOrder.street')) {
        if ($event.target.value === "") {
          this.$refs.street_error.style.display = "block";
          // this.$refs.street_error.innerHTML = this.$t('text.errors.streetMissing');
          this.$refs.street_input.style.border = "1px solid red";
          this.$refs.street_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.street_error.style.display = "none";
          this.$refs.street_error.innerHTML = "";
          this.$refs.street_input.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t('text.editOrder.city')) {
        if ($event.target.value === "") {
          this.$refs.city_error.style.display = "block";
          // this.$refs.city_error.innerHTML = this.$t('text.errors.cityMissing');
          this.$refs.city_input.style.border = "1px solid red";
          this.$refs.city_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.city_error.style.display = "none";
          this.$refs.city_error.innerHTML = "";
          this.$refs.city_input.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
     
      if ($event.target.placeholder === this.$t('text.editOrder.phonePlaceholder')) {
        if ($event.target.value === "") {
          this.$refs.phone_error.style.display = "block";
          // this.$refs.phone_error.innerHTML =
            this.$t('text.errors.contactPhoneMissing');
          this.$refs.phone_input.style.border = "1px solid red";
          this.$refs.phone_error.style.color = "red";
          this.formIsValid = false;
        } else {
          if (
            $event.target.value.length < 10 ||
            $event.target.value.length > 13
          ) {
            this.$refs.phone_error.style.display = "block";
            this.$refs.phone_error.style.color = "red";
            this.$refs.phone_input.style.border = "1px solid red";
            this.$refs.phone_error.innerHTML =
              this.$t('text.errors.shortPhoneNumber');
            this.formIsValid = false;
            return;
          }
          this.$refs.phone_error.style.display = "none";
          this.$refs.phone_input.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
    },
    getProducts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products`,
          configObject.authConfig()
        )
        .then(response => {
          this.isButtonDisabled = true;
          this.showLoader = false;
          this.prodList = response.data;
          let pms = response.data.filter(
            product => product.name.toLowerCase() == "pms"
          );
          if(pms.length > 0){
            this.pmsPrice = pms[0].price;
          }
          let ago = response.data.filter(
            product => product.name.toLowerCase() == "ago"
          );
          if(ago.length > 0){
            this.agoPrice = ago[0].price;
          }
          let dpk = response.data.filter(
            product => product.name.toLowerCase() == "dpk"
          );
          if(dpk.length > 0){
            this.dpkPrice = dpk[0].price;
          }

          this.price = this.agoPrice;
          this.prodArray = response.data
            .map(prod => {
              return prod.name;
            });
            this.isButtonDisabled = false;
        })
        .catch(error => {

        });
    },
    getStates() {
      this.axios
        .get(
         `${configObject.apiBaseUrl}/Branch/States`, 
          configObject.authConfig()
        )
        .then(response => {
          this.states = response.data;
         
        })
        .catch(error => {
        });
    },
    getPreviousOrderAddress() {
      this.axios
        .get(
         `${configObject.apiBaseUrl}/Order/PreviousAddress`, 
          configObject.authConfig()
        )
        .then(response => {
          this.PreviousAddress = response.data;
         
        })
        .catch(error => {
        });
    },
    updateOrder($event) {
      $event.preventDefault();
       if(!this.order.quantity ) {
        this.$toast.open({
          message: this.$t('text.editOrder.quantityMissing'),
          type: "error",
          duration: 3000
        });
        return 
      }
       if(!this.order.contactName ) {
        this.$toast.open({
          message: this.$t('text.errors.contactNameMissing'),
          type: "error",
          duration: 3000
        });
        return 
      }
      if(!this.order.street ) {
        this.$toast.open({
          message: this.$t('text.errors.streetMissing'),
          type: "error",
          duration: 3000
        });
        return 
      }
      if(!this.order.city ) {
        this.$toast.open({
          message: this.$t('text.errors.cityMissing'),
          type: "error",
          duration: 3000
        });
        return 
      }
      
       if(!this.order.state ) {
        this.$toast.open({
          message: this.$t('text.errors.stateMissing'),
          type: "error",
          duration: 3000
        });
        return 
      }
      if(!this.order.contactPhone ) {
        this.$toast.open({
          message: this.$t('text.errors.contactPhoneMissing'),
          type: "error",
          duration: 3000
        });
        return 
      }
      if(this.order.contactPhone.length < 10 || this.order.contactPhone.length > 13) {
        this.$toast.open({
          message: this.$t('text.errors.shortPhoneNumber'),
          type: "error",
          duration: 3000
        });
        return 
      }
      let data;
      data = {
        "id": this.order.id,
        "productId": this.order.productId,
        "companyId": this.$route.query.companyId ? this.$route.query.companyId : this.company.id,
        "quantity": parseInt(this.order.quantity),
        "status": this.order.status,
        "contactName": this.order.contactName,
        "contactPhone": this.order.contactPhone,
        "street": this.order.street,
        "city": this.order.city,
        "state": this.order.state,
      };
      
      
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Order/Product`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({name: "manage_orders"})
          this.$toast.open({
            message: this.$t('text.editOrder.successfullyUpdated'),
            type: "success",
            duration: 5000
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch(error => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000
          })
        });
    }
  }
};
</script>

<style>
@media screen and (max-width: 602px) {
  .new-staff {
    width: 82%;
}
}
</style>
